import { faSpinner } from '@awesome.me/kit-4a6bf60416/icons/classic/regular';

import { Icon } from '@/components/ui/icon';
import { SmallText } from '@/components/ui/typography';

interface LoadingOverlayProps {
  show: boolean;
}

export function LoadingOverlay({ show }: LoadingOverlayProps) {
  if (!show) return null;

  return (
    <div className="absolute inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center z-20">
      <div className="flex flex-col items-center gap-2">
        <Icon icon={faSpinner} className="h-8 w-8 text-foreground animate-spin" />
        <SmallText className="font-medium">Adding to Site Files...</SmallText>
      </div>
    </div>
  );
}

interface CreditProps {
  userName: string;
  userUrl: string;
}

export function PhotoCredit({ userName, userUrl }: CreditProps) {
  return (
    <div className="opacity-0 group-hover/unsplash-image-card:opacity-100 transition-opacity duration-150 absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-background via-background/70 to-transparent flex items-end p-2">
      <SmallText className="text-xs">
        Photo by{' '}
        <a
          href={`${userUrl}?utm_source=lawlytics&utm_medium=referral`}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          {userName}
        </a>
      </SmallText>
    </div>
  );
}
